import { createContext } from "react";

import { TemplateVariableDefinitions } from "./definitions";

export const Context = createContext(new TemplateVariableDefinitions([]));
